import { CaseFormContext } from "contexts/CaseFormContext";
import useCaseForm from "helpers/hooks/useCaseForm";
import { Form } from "generated/graphql";

interface Props {
  lensId: number;
  caseId: number;
  form: Form;
  children: React.ReactNode;
}

const CaseFormProvider = ({ lensId, caseId, form, children }: Props) => {
  const caseForm = useCaseForm({ lensId, caseId, form });
  return <CaseFormContext.Provider value={caseForm}>{children}</CaseFormContext.Provider>;
};

export default CaseFormProvider;
